// extracted by mini-css-extract-plugin
module.exports = {"C_container":"CityComponent-module__C_container","C_content":"CityComponent-module__C_content","brdCrmb":"CityComponent-module__brdCrmb"};